<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <section class="profile profile-loader">
    <div class="mb-20">
      <div class="mr-20">
        <div class="card">
          <div class="!tw-flex !tw-justify-between">
            <Skeleton height="12px" width="98px" class="mt-10" />
            <div>
              <Skeleton height="34px" width="152px" class="mr-12" />
              <Skeleton height="34px" width="66px" />
            </div>
          </div>
          <ElDivider class="mb-20 mt-14" />
          <div class="!tw-flex !tw-flex-col">
            <Skeleton height="9px" width="195px" />
            <div class="!tw-flex !tw-flex-row">
              <div class="!tw-flex !tw-flex-col !tw-grow">
                <Skeleton height="9px" width="76px" class="mt-20" />
                <Skeleton height="12px" width="92px" class="mt-10" />
                <Skeleton height="9px" width="76px" class="mt-30" />
                <Skeleton height="12px" width="92px" class="mt-10" />
                <Skeleton height="9px" width="76px" class="mt-30" />
                <Skeleton height="12px" width="92px" class="mt-10" />
              </div>
              <div class="!tw-flex !tw-flex-col !tw-grow">
                <Skeleton height="9px" width="76px" class="mt-20" />
                <Skeleton height="12px" width="92px" class="mt-10" />
                <Skeleton height="9px" width="76px" class="mt-30" />
                <Skeleton height="12px" width="92px" class="mt-10" />
                <Skeleton height="9px" width="76px" class="mt-30" />
                <Skeleton height="12px" width="92px" class="mt-10" />
              </div>
            </div>
          </div>
          <ElDivider class="mb-0 mt-30" />
          <div class="!tw-flex !tw-flex-row mb-10">
            <div class="!tw-flex !tw-flex-col !tw-grow">
              <Skeleton height="9px" width="76px" class="mt-20" />
              <Skeleton height="12px" width="150px" class="mt-10" />
            </div>
            <div class="!tw-flex !tw-flex-col !tw-grow">
              <Skeleton height="9px" width="76px" class="mt-20" />
              <Skeleton height="12px" width="150px" class="mt-10" />
            </div>
          </div>
          <Skeleton height="9px" width="76px" class="mt-20" />
          <Skeleton height="12px" width="350px" class="mt-10" />
        </div>
      </div>
      <div class="mr-20">
        <div class="card mb-20">
          <div class="!tw-flex !tw-justify-between">
            <Skeleton height="12px" width="136px" class="mr-12 mt-10 mb-0" />
            <div>
              <Skeleton height="34px" width="67px" />
            </div>
          </div>
          <ElDivider class="mb-20 mt-14" />
          <Skeleton height="10px" width="180px" />
          <Skeleton height="10px" width="100px" class="mt-20" />
          <Skeleton height="10px" width="180px" class="mt-20" />
          <Skeleton height="10px" width="100px" class="mt-20" />
        </div>
        <div class="card !tw-flex !tw-flex-col">
          <Skeleton height="12px" width="68px" class="mr-12 mt-10 mb-30" />
          <Skeleton width="auto" height="auto" class="!tw-grow" />
        </div>
      </div>
      <div>
        <div class="card mb-20">
          <div class="!tw-flex !tw-justify-between">
            <Skeleton height="12px" width="136px" class="mr-12 mt-10 mb-0" />
            <div>
              <Skeleton height="34px" width="67px" />
            </div>
          </div>
          <ElDivider class="mb-20 mt-14" />
          <Skeleton height="10px" width="300px" class="mb-20" />
          <Skeleton height="10px" width="180px" />
          <Skeleton height="10px" width="100px" class="mt-20" />
        </div>
      </div>
    </div>
    <div>
      <div class="card">
        <div class="mb-20">
          <div>
            <div>
              <Skeleton height="12px" width="68px" class="mr-12 mt-10 mb-0" />
            </div>
          </div>
          <div>
            <div>
              <Skeleton height="34px" width="155px" class="mr-12" />
            </div>
            <div>
              <Skeleton height="34px" width="80px" class="mr-12" />
              <Skeleton height="34px" width="212px" />
            </div>
          </div>
        </div>
        <Skeleton width="auto" height="auto" />
      </div>
    </div>
  </section>
</template>

<script>
import Skeleton from '@/components/Skeleton';

export default {
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/profile/profile';
</style>
